import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { Popup,Icon,DatetimePicker,Button,Toast,Dialog,Loading } from "vant";
import store from './store'
import fastClick from "fastclick";
import axios from 'axios'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)


// fastClick.attach(document.body);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Loading);
Vue.config.productionTip = false;

//为了配合mock引入axios
Vue.prototype.$axios = axios

Vue.prototype.goBeforeLoginUrl = () => {
    let url = $cookies.get('history')
    if(url){
        router.push(`./${url}`)
    }
}

router.beforeEach((to,from,next) => {
    if(! $cookies.get('history') != '' && to.path != '/login'){
        store.dispatch('SAVEURLACTION',from.fullPath)
        // next('/login')
        next()
        return false
    }else{
        next()
    }
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
